// Admin mock data for producers
// This will be replaced with real Supabase data in a future iteration

export type ProducerStatus = 'draft' | 'public';

export interface AdminProducer {
  id: string;
  name: string;
  shortDescription?: string; // Now optional
  longDescription?: string;
  address: string;
  city: string;
  region: string;
  lat: number;
  lng: number;
  categories: string[];
  phone?: string;
  website?: string;
  instagram?: string;
  email?: string;
  openingHoursText?: string;
  coverUrl?: string;
  galleryUrls: string[];
  status: ProducerStatus;
  verified: boolean;
  createdAt: string;
  updatedAt: string;
}

export const AVAILABLE_CATEGORIES = [
  'Kött',
  'Ägg',
  'Mejeri',
  'Självplock',
  'Café',
  'Grönsaker',
  'Frukt & Bär',
  'Honung',
  'Bröd & Bageri',
  'Fisk',
  'Gårdsbutik',
  'Boende',
];

export const REGIONS = [
  'Skåne',
  'Blekinge',
  'Småland',
  'Halland',
  'Västergötland',
  'Östergötland',
  'Bohuslän',
  'Dalsland',
  'Värmland',
  'Närke',
  'Södermanland',
  'Uppland',
  'Dalarna',
  'Gästrikland',
  'Hälsingland',
  'Medelpad',
  'Ångermanland',
  'Jämtland',
  'Västerbotten',
  'Norrbotten',
  'Gotland',
  'Öland',
];

// Initial mock data
export const initialMockProducers: AdminProducer[] = [
  {
    id: '1',
    name: 'Björkeby Gård',
    shortDescription: 'Ekologiska grönsaker och ägg mitt i Sörmland.',
    longDescription: 'Familjedriven gård sedan tre generationer. Vi odlar säsongens grönsaker och har frigående höns.',
    address: 'Björkebyvägen 12',
    city: 'Gnesta',
    region: 'Södermanland',
    lat: 59.0512,
    lng: 17.3078,
    categories: ['Ägg', 'Grönsaker', 'Gårdsbutik'],
    phone: '070-123 45 67',
    website: 'https://bjorkebygard.se',
    instagram: '@bjorkebygard',
    openingHoursText: 'Fre–Sön 10–16. Ring gärna först.',
    coverUrl: '',
    galleryUrls: [],
    status: 'public',
    verified: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-12-20T14:30:00Z',
  },
  {
    id: '2',
    name: 'Svenssons Lamm',
    shortDescription: 'Naturbeteskött från egna djur på Österlen.',
    address: 'Lammgatan 5',
    city: 'Simrishamn',
    region: 'Skåne',
    lat: 55.5569,
    lng: 14.3503,
    categories: ['Kött'],
    phone: '0414-123 45',
    website: 'https://svenssonslamm.se',
    openingHoursText: 'Beställning via hemsida. Hämtning lördagar.',
    coverUrl: '',
    galleryUrls: [],
    status: 'public',
    verified: true,
    createdAt: '2024-02-10T09:00:00Z',
    updatedAt: '2024-11-15T11:00:00Z',
  },
  {
    id: '3',
    name: 'Ängens Mejeri',
    shortDescription: 'Hantverksmejeri med ost och yoghurt.',
    address: 'Mejerivägen 8',
    city: 'Falkenberg',
    region: 'Halland',
    lat: 56.9054,
    lng: 12.4912,
    categories: ['Mejeri', 'Café', 'Gårdsbutik'],
    phone: '0346-789 00',
    openingHoursText: 'Tisdag–Söndag 11–17',
    coverUrl: '',
    galleryUrls: [],
    status: 'draft',
    verified: false,
    createdAt: '2024-06-01T12:00:00Z',
    updatedAt: '2024-06-01T12:00:00Z',
  },
  {
    id: '4',
    name: 'Norrby Bär',
    shortDescription: 'Självplock av jordgubbar och hallon i Dalarna.',
    address: 'Bärvägen 22',
    city: 'Leksand',
    region: 'Dalarna',
    lat: 60.7295,
    lng: 14.9994,
    categories: ['Självplock', 'Frukt & Bär'],
    phone: '070-999 88 77',
    instagram: '@norrbybar',
    openingHoursText: 'Säsong juni–augusti, dagligen 8–20',
    coverUrl: '',
    galleryUrls: [],
    status: 'public',
    verified: false,
    createdAt: '2024-03-20T08:00:00Z',
    updatedAt: '2024-08-10T16:00:00Z',
  },
  {
    id: '5',
    name: 'Kusthonungs Bigård',
    shortDescription: 'Honung från vilda blomsterängar längs Bohuskusten.',
    address: 'Klippvägen 3',
    city: 'Lysekil',
    region: 'Bohuslän',
    lat: 58.2747,
    lng: 11.4356,
    categories: ['Honung'],
    email: 'hej@kusthonung.se',
    website: 'https://kusthonung.se',
    openingHoursText: 'Kontakta oss för besök.',
    coverUrl: '',
    galleryUrls: [],
    status: 'draft',
    verified: false,
    createdAt: '2024-07-05T14:00:00Z',
    updatedAt: '2024-07-05T14:00:00Z',
  },
];
